import React from 'react'
import { Center, Text } from '@chakra-ui/react'

export default function UnreadIndicator({
    unreadCounts,
}: {
    unreadCounts: number
}) {
    const isUnread = unreadCounts > 0

    if (!isUnread) return null

    return (
        <Center bg="brand.500" px={2} py={0} rounded="full" mr={1}>
            <Text fontSize="xs" fontWeight="bold" color="white">
                {unreadCounts}
            </Text>
        </Center>
    )
}
